<footer class="py-3.5 px-1 sm:px-4 min-h-[24px] bg-white border-t border-[#cccccc] text-[clamp(10px,2.6vw,14px)] text-center sm:text-right" id="app-footer">
  <span class="text-[var(--brand-primary)]">{{ appName }}</span>
  <span class="text-[#34383c]"> | Powered by Shift Digital - &copy; {{ currentYear }} Shift Digital</span>
</footer>
